import BaseListPresenter from "../../../../base/BaseListPresenter";
import { generateUniqueId } from "../../../../components/common/Converter";

class AllowanceAssignTablePresenter extends BaseListPresenter {
  constructor(
    view,
    findObjectUseCase,
    countObjectUseCase,
    deleteObjectUseCase,
    upsertUseCase,
    exportCSVUseCase,
    addSchemaUseCase,
    updateSchemaUseCase,
    deleteSchemaUseCase
  ) {
    super(view, findObjectUseCase, countObjectUseCase, deleteObjectUseCase);
    this.upsertUseCase = upsertUseCase;
    this.exportCSVUseCase = exportCSVUseCase;
    this.addSchemaUseCase = addSchemaUseCase;
    this.updateSchemaUseCase = updateSchemaUseCase;
    this.deleteSchemaUseCase = deleteSchemaUseCase;
    this.view = view;
  }
  init() {
    this.limit = 10;
    this.where = { id: "" };
    this.search = {};
    this.filter = {};
    this.include = ["all"];
    this.keys = undefined; // if keys are specified, only those keys will be returned
    this.sort = { createdAt: -1 };
    this.progress = true;
    this.reset();
  }

  createQuery() {
    const skip = (this.current - 1) * this.limit;
    const query = {
      limit: this.limit,
      skip: skip,
      where: { ...this.where, ...this.search, ...this.filter },
      include: this.include,
    };
    if (this.sort) {
      query.sort = this.sort;
    }
    const keys = this.keys || this.view.getKeys() || [];
    if (keys.length > 0) {
      query.keys = keys;
    }
    return query;
  }

  async findObjects() {
    const collection = this.view.getCollectionName();
    const query = this.createQuery();
    try {
      this.showProgress();
      this.findObjectUseCase.abort();
      const objects = await this.findObjectUseCase.execute(collection, query);
      this.objects = this.objects.concat(objects);
      this.view.setObjects(objects);
      this.view.setCurrent(this.current);
      this.hideProgress();
    } catch (error) {
      this.hideProgress();
      this.view.showError(error);
    }
    this.progress = false;
  }

  setCurrentPage(page) {
    this.current = page;
    this.documents = [];
    this.view.setCurrent(page);
    this.view.setObjects([]);
    this.findObjects();
  }

  handleSaveClick = () => {
    // let employeeEmail = [];
    // let empID = [];
    const id = generateUniqueId();
    // this.view.props.selected.forEach((data) => {
    //   employeeEmail.push(data.email);
    //   empID.push(data.id);
    // });

    const {
      allowanceList,
      count,
      current,
      limit,
      loading,
      object,
      objectID,
      objects,
      selected,
      total,
      ...resObj
    } = this.view.state;

    const data = {
      id,
      ...resObj,
      // empID,
    };

    if (this.view.state.objectID !== "") {
      this.view.setState((prevState) => ({
        object: prevState.object.map((item) =>
          item.id === prevState.objectID ? data : item
        ),
      }));
      this.view.refetchData();
    } else {
      this.view.setState((preState) => {
        const dataExists = preState.object.some(
          (item) => item.allowance === data.allowance
        );

        if (!dataExists) {
          return { object: [...preState.object, data] };
        }
      });
    }
    this.view.refetchData();
  };
}
export default AllowanceAssignTablePresenter;
